<template>
  <Transition name="valid-riddle-transition">
    <p v-if="visible" class="riddle__valid">{{ $beet.options.hunt.labels.riddle.valid }}</p>
  </Transition>
</template>

<script>
export default {
  name: 'RiddleValid',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
